import React from 'react';
import useOnTextEditorScroll from 'components/text-editor/components/controls/hooks/use-on-text-editor-scroll';
import useCustomEditor from 'components/text-editor/hooks/use-custom-editor';
import useEventListener from 'hooks/use-event-listener';
import { notEqual } from 'utils/js';

export default function useMarkupMenuPositionStyles() {
  const editor = useCustomEditor();
  const [styles, setStyles] = React.useState({});

  useOnTextEditorScroll(updateStyles);

  useEventListener('resize', updateStyles);

  React.useEffect(() => {
    editor.selection && updateStyles();
  }, [editor.selection]);

  function updateStyles() {
    const position = getSelectionPosition();

    if (position && notEqual(styles, position)) {
      setStyles(position);
    }
  }

  return styles;
}

function rectToStyles(rect: DOMRect): React.CSSProperties {
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height,
  };
}

function getSelectionPosition() {
  const selection = window.getSelection();

  if (selection && selection.rangeCount > 0) {
    const rect = selection.getRangeAt(0).getBoundingClientRect();

    return rect.top !== 0 ? rectToStyles(rect) : null;
  }

  return null;
}
